<script setup>
defineProps({
  bool: { type: Boolean, required: false, default: false },
  text: { type: String, required: false, default: 'Toggle item ' },
  chipText: { type: String, required: false, default: 'Toggle' },
  icon: { type: String, required: false, default: '' }
})

const emit = defineEmits(['toggle'])
</script>

<template>
  <v-tooltip open-delay="500" location="bottom">
    <template v-slot:activator="{ props }">
      <v-chip
        v-bind="props"
        label
        rounded="lg"
        elevation="0"
        color="primary"
        :prepend-icon="icon"
        @click="emit('toggle')"
        :variant="!bool ? 'outlined' : 'flat'"
      >
        {{ chipText }}
      </v-chip>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>